import { createFileRoute } from '@tanstack/react-router'
import node, {
  type newOrganizationPageQuery,
} from '#gen/relay/newOrganizationPageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute('/_dashboard/new-organization')({
  staticData: { title: 'Create organization' },
  async loader({ context }) {
    return context.preload<newOrganizationPageQuery>(node)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/account/new-organization-page'),
    'NewOrganizationPage',
  ),
})
